import { RootState } from '..'
import { IState } from './type'

export const selectWhitelist = (state: RootState): IState => state.whitelist
